import { render, staticRenderFns } from "./TpaGameModal.vue?vue&type=template&id=75f726e4&scoped=true&"
import script from "./TpaGameModal.vue?vue&type=script&lang=js&"
export * from "./TpaGameModal.vue?vue&type=script&lang=js&"
import style0 from "./TpaGameModal.vue?vue&type=style&index=0&id=75f726e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f726e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VContainer,VRow,VSelect,VTextField})
